import { Component, Input } from '@angular/core';
import { Child } from '../../models/child';
import { Packet } from '../../models/packet';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'child-info-packet-summary',
  templateUrl: './child-info-packet-summary.html',
  styleUrls: ['./child-info-packet-summary.scss'],
})

export class ChildInfoPacketSummary {

  /**
   * 패킷이 없는 경우 출력 문자열
   */
  private static DEFAULT: string = '-';

  /**
   * 오늘이 패킷 만료기간과 가까운 정도 기준
   */
  private static NUM_DIFF_NEAR: number = 7;

  /**
   * 센터 이름
   */
  center: string = ChildInfoPacketSummary.DEFAULT;

  /**
   * 패킷 이름
   */
  packetName: string = ChildInfoPacketSummary.DEFAULT;

  /**
   * 패킷 시작 일자
   */
  packetStart: string = ChildInfoPacketSummary.DEFAULT;

  /**
   * 패킷 종료 일자
   */
  packetEnd: string = ChildInfoPacketSummary.DEFAULT;

  /**
   * 오늘이 종료일자와 가까운지 여부
   * TODO: 필요한지 여부
   */
  private isNowNearsEnd: boolean = false;

  constructor() {}

  @Input('packet') private set packet(pkt: Packet) {
    if (pkt) {
      this.packetName = pkt.program ? pkt.program : ChildInfoPacketSummary.DEFAULT;

      if (pkt.start) {
        const startYear = pkt.start.getFullYear().toString();
        const startMonth = SharedService.addZero(pkt.start.getMonth() + 1);
        const startDate = SharedService.addZero(pkt.start.getDate());
        this.packetStart = `${startYear}.${startMonth}.${startDate}`;
      } else {
        this.packetStart = ChildInfoPacketSummary.DEFAULT;
      }

      if (pkt.end) {
        const endYear = pkt.end.getFullYear().toString();
        const endMonth = SharedService.addZero(pkt.end.getMonth() + 1);
        const endDate = SharedService.addZero(pkt.end.getDate());
        const diff = pkt.end.getTime() - new Date().getTime();
        const diffDate = diff / (1000 * 60 * 60 * 24);
        this.isNowNearsEnd = diffDate < ChildInfoPacketSummary.NUM_DIFF_NEAR;
        this.packetEnd = `${endYear}.${endMonth}.${endDate}`;
      } else {
        this.packetEnd = ChildInfoPacketSummary.DEFAULT;
      }
    } else {
      this.packetName = ChildInfoPacketSummary.DEFAULT;
      this.packetStart = ChildInfoPacketSummary.DEFAULT;
      this.packetEnd = ChildInfoPacketSummary.DEFAULT;
    }
  }

  @Input('centerName') private set centerName(child: Child) {
    if (child) {
      this.center = child.centerName;
    } else {
      this.center = ChildInfoPacketSummary.DEFAULT;
    }
  }
}
